"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = exports.reducer = exports.actions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../utils/api");
const index_1 = require("../../utils/index");
const constants_1 = require("./constants");
const SLICE_NAME = 'resultsProviderV2';
exports.initialState = {
    entries: {},
    fetchItems: api_1.requestInitialState,
    fetchItem: {},
    linkedEvents: {},
    list: {
        config: constants_1.EVENT_RESULTS_LIST_CONFIG,
        filters: constants_1.EVENT_RESULTS_LIST_FILTERS,
        page1Number: 0,
        page2Number: 0,
        before: constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
        page1: constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
        page2: constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
    },
};
/**
 * Сейчас слайс работает только с пагинацией ( без поллинга )
 * Поэтому все id результатов складываются в page1
 * page2.loading - индикатор загрузки следующих событий
 * */
const slice = (0, toolkit_1.createSlice)({
    name: SLICE_NAME,
    initialState: exports.initialState,
    reducers: {
        setListInfo(state, action) {
            const { config } = action.payload;
            state.list = {
                ...state.list,
                config,
                page1Number: 1,
                filters: constants_1.EVENT_RESULTS_LIST_FILTERS,
                page1: constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
                page2: constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
            };
        },
        fetchEventResults(state) {
            state.fetchItems.loading = true;
            state.fetchItems.error = null;
        },
        fetchEventResultsSuccess(state) {
            state.fetchItems.loading = false;
            state.fetchItems.error = null;
            state.fetchItems.loaded = true;
        },
        fetchEventResultsError(state, { payload }) {
            state.fetchItems.loading = false;
            state.fetchItems.error = payload;
            state.fetchItems.loaded = true;
        },
        fetchEventResult(state, action) {
            const { eventId } = action.payload;
            state.fetchItem[eventId] = {
                ...api_1.requestInitialState,
                loading: true,
                error: null,
            };
        },
        fetchEventResultSuccess(state, action) {
            var _a;
            const { eventId } = action.payload;
            state.fetchItem[eventId] = {
                ...((_a = state.fetchItem[eventId]) !== null && _a !== void 0 ? _a : api_1.requestInitialState),
                loading: false,
                loaded: true,
                error: null,
            };
        },
        fetchEventResultError(state, action) {
            var _a;
            const { eventId, error } = action.payload;
            state.fetchItem[eventId] = {
                ...((_a = state.fetchItem[eventId]) !== null && _a !== void 0 ? _a : api_1.requestInitialState),
                loading: false,
                loaded: true,
                error,
            };
        },
        updateEventResults(state, action) {
            state.entries = {
                ...state.entries,
                ...(0, index_1.toIdsMap)(action.payload.eventResults),
            };
        },
        fetchEventResultsList(state) {
            state.list.page1 = {
                ...constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
                loading: true,
            };
        },
        fetchEventResultsListSuccess(state, action) {
            const { reqData, resData } = action.payload;
            const newPageIdsArray = (0, index_1.toIdsArray)(resData.items);
            state.list.page1Number = 1;
            state.list.page1 = {
                loading: false,
                loaded: true,
                polling: false,
                eventResultsIds: newPageIdsArray,
                paginationKeyBackward: resData.paginationKeyBackward,
                paginationKeyForward: resData.paginationKeyForward,
                paginationKey: reqData.pageKey,
                paginationKeyDirection: reqData.pageKeyDirection,
            };
        },
        fetchEventResultsListError(state) {
            state.list.page1 = constants_1.EVENT_RESULT_LIST_EMPTY_PAGE;
        },
        fetchEventResultsListNextPage() { },
        fetchEventResultsListNextStart(state) {
            state.list.page2.loading = true;
        },
        fetchEventResultsListNextSuccess(state, action) {
            const { reqData, resData } = action.payload;
            const newPageIdsArray = (0, index_1.toIdsArray)(resData.items);
            state.list.page2.loading = false;
            state.list.page1 = {
                loaded: true,
                loading: false,
                polling: false,
                eventResultsIds: [
                    ...state.list.page1.eventResultsIds,
                    ...newPageIdsArray,
                ],
                paginationKeyBackward: resData.paginationKeyBackward,
                paginationKeyForward: resData.paginationKeyForward,
                paginationKey: reqData.pageKey,
                paginationKeyDirection: reqData.pageKeyDirection,
            };
        },
        fetchEventResultsListNextError(state) {
            state.list.page2.loading = false;
            state.list.page1Number -= 1;
        },
        setFilters(state, action) {
            state.list.page1 = {
                ...constants_1.EVENT_RESULT_LIST_EMPTY_PAGE,
                loading: true,
            };
            state.list.filters = {
                ...state.list.filters,
                ...action.payload.filters,
            };
        },
        fetchLinkedEvents(_state, _action) { },
        fetchLinkedEventsSuccess(state, { payload }) {
            state.linkedEvents = {
                ...state.linkedEvents,
                ...(0, index_1.toIdsMap)(payload.events),
            };
        },
    },
});
exports.actions = slice.actions, exports.reducer = slice.reducer, exports.name = slice.name;
//# sourceMappingURL=slice.js.map